export const formatPhoneNumber = (phone: string | null | undefined, placeholder: string = ""): string => {
  if(!phone) {
    return placeholder;
  }
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return phone;
};